<template>
  <div
    id="app"
    class="content"
    :class="{
      pc: $route.meta.pc,
      [motif]: true
    }"
  >
    <div class="main-head" v-if="$route.meta.pc && !mobileWidth && !$route.meta.isPcNull">
      <router-link to="/">
        <img :src="setImgUrl('/img_logo_mini.png')" alt="" />
      </router-link>
      <div @click="openDownloadWindow()" class="download-ico">
        <svg-icon className="box-icon" iconClass="phone"></svg-icon>
        <div>下载App</div>
      </div>

      <div class="about-us" @click="$store.commit('setBounceAboutUs', true)">关于智能派AI</div>
      <div
        v-if="!$tools.isIEClient()"
        class="motif-box"
        :class="{ 'white-box': motif == 'whiteTopic' }"
      >
        <div class="black" @click="setMotif('blackTopic')">
          <img :src="setImgUrl('/ic_night.png')" alt="" />
        </div>
        <div class="white" @click="setMotif('whiteTopic')">
          <img :src="setImgUrl('/ic_day.png')" alt="" />
        </div>
      </div>
      <div class="ie-tips" v-else>
        为了更好地使用体验，建议使用除ie以外浏览器
      </div>
    </div>

    <TopNav
      v-else-if="mobileWidth && $route.meta.isNoHead"
      :title="topTitleObj.title || $route.meta.mobileTitle"
      :backUrl="topTitleObj.backUrl"
    >
    </TopNav>

    <div
      class="min"
      :class="{
        'content-div': !$route.meta.content,
        'pc-flex': $route.meta.pc,
        'moblie-mine': isMobileMine && $route.name == 'Index',
      }"
      v-if="userLoaded"
    >
      <TaberPC class="pc-left" v-if="$route.meta.pc && !$route.meta.isPcNull"></TaberPC>

      <div style="position: relative;flex: 1;height: 100%;" :style="{'display': $route.meta.pc ? 'flex' : 'block'}">
        <router-view
          :class="{ 'pc-right': $route.meta.pc && !$route.meta.isPcNull, 'ie-class': $tools.isIEClient() }"
          v-if="!$route.meta.keepAlive"
          v-wechat-title="$route.meta.title"
        ></router-view>
        <keep-alive>
          <router-view
            :class="{
              'pc-right': $route.meta.pc,
              'ie-class': $tools.isIEClient(),
            }"
            v-if="$route.meta.keepAlive"
            v-wechat-title="$route.meta.title"
          ></router-view>
        </keep-alive>
        <div class="statement-box" v-if="$route.meta.pc && !mobileWidth && !$route.meta.isPcNull">智能派AI V1.0.0 · 版权所有&nbsp;©&nbsp;智能派(厦门)科技有限公司 · <span @click="isProtocol('web_service')">《用户协议》</span>·<span @click="isProtocol('web_private')">《隐私政策》</span> · <a target="_blank" style="color:rgba(152, 159, 173, 0.6)" href="https://beian.miit.gov.cn/">闽ICP备2023009012号</a><br />所有内容均由人工智能模型（AI）输出，其内容的准确性和完整性无法保证，不代表我们的态度或观点。</div>
      </div>
    </div>

    <div v-if="$route.meta.pc">
      <PopupPC v-model="lodinShow" :canOverlay="false" class="login-pop">
        <Login :closeImg="setImgUrl('/ic_close.png')" :isPop="true"></Login>
      </PopupPC>

      <PopupPC v-model="aboutUsShow" :title="inPc ? '关于智能派AI' : ''" :position="inPc ? 'center' : 'bottom'" :isoff="inPc" :canOverlay="!inPc" class="about-us-pop" :class="{'position-bottom': !inPc}">
        <div class="about-us-box">
          智能派(厦门)科技有限公司，于2023年开始运营的智能派AI平台，是一款 AI 智能聊天平台。<br />
          <br />
          平台使用先进的大语言模型技术，由AI通过对话互动的方式，帮助每个人获取信息、知识和灵感。<br />
          <br />
          主要功能<br />
          1、AI专家：在各领域深入研究和专业知识的AI，包括科技、财经、心理等领域；<br />
          2、应用：减少模板化工作、获取灵感，类似周报生成器、爆款标题、代码编程、简历生成等。<br />
          <br />
          电话：1739262047<br />
          微信服务号：AiFast<br />
          地址：厦门市软件园二期望海路21号之一501<br />
        </div>
      </PopupPC>
    </div>
  </div>
</template>

<script>
import { updateAccessToken } from "./http";
import TaberPC from "./views/TaberPC.vue";
import TopNav from "./components/TopNav.vue";
import Login from "./views/Login.vue";
import PopupPC from "./components/PopupPC.vue";
import Popup from "./components/Popup.vue";

export default {
  name: "FastApp",
  components: { TaberPC, Login, PopupPC, Popup, TopNav },
  provide() {
    return {
      mobileWidth: this.getMobileWidth,
    };
  },
  data() {
    return {
      userLoaded: false,
      routeName: ["Extend", "PromoteVip", "Login", "Become", "Index"],
      upPage: [
        // 需要更新数据的页面
        "Mine",
        "",
      ],
      lodinShow: this.$store.state.bounceLodin,
      aboutUsShow: this.$store.state.bounceAboutUs,
      mobileWidth: false, // 是否达到移动端的屏幕宽度 768px
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user() {
      return this.$store.state.user;
    },
    distribution() {
      return this.$store.state.distribution;
    },
    motif() {
      if(this.inPc){
        return this.$store.state.motif;
      }

      return 'blackTopic';
    },
    topTitleObj() {
      console.log(this.$store.state.topTitleObj,111111);
      return this.$store.state.topTitleObj;
    },
    isMobileMine() {
      return this.$store.state.isMobileMine;
    },
  },
  watch: {
    "$store.state.bounceLodin": {
      handler(newVal) {
        this.lodinShow = newVal;
      },
    },
    lodinShow(newVal) {
      this.$store.commit("setBounceLodin", newVal);
    },
    "$store.state.bounceAboutUs": {
      handler(newVal) {
        this.aboutUsShow = newVal;
      },
    },
    aboutUsShow(newVal) {
      this.$store.commit("setBounceAboutUs", newVal);
    },
    $route: {
      async handler(to, from) {
        if (!to.name) return false;

        if (to.name == "Download") {
          this.userLoaded = true;
          return false;
        }

        if(from.name == 'Index'){
          this.$store.commit('setIsMobileMine', false);
        }

        if (to.query.title) {
          var brand_name = " - 智能派AI";

          // if (this.$tools.isIOSEnvironment()) {
          //   brand_name = " - FastGPT";
          // }
          to.meta.title = to.query.title + brand_name;
        }

        if (to.meta.distr) {
          if (!from.name || from.name != "Login") {
            await this.updateUserInfo(true);
            await this.updateDistributionInfo(true);
          }
        } else {
          await this.updateUserInfo(true);
          this.userLoaded = true;
          return false;
        }

        this.userLoaded = true;
        // 使用 this.$refs.myRouterView 获取 router-view 实例，并访问其 $route 属性
        let isRouter = this.routeName.some((item) => item == to.name);

        // 下载页不去进行任何操作
        if (to.name == "Download") return false;

        // 微信内获取授权信息
        // if(this.$tools.isWeixinClient()){
        //   this.updateWeiXinUserLogin();
        // }

        // 匹配页面不去进行以下操作
        if (isRouter) return false;

        // if(!this.user){
        // this.unLoginHandle();
        // return false;
        // }
        if (!this.token) {
          // this.unLoginHandle();
          let accessToken = await updateAccessToken();
          this.$store.commit("setToken", accessToken);
          if (!accessToken) {
            return false;
          }
        }

        if (
          !this.distribution &&
          (!from.name || from.name != "Login") &&
          (!from.name || from.name != "Become") &&
          to.meta.distr
        ) {
          // console.log(3122131231323,from,to);
          this.$router.push({ name: "Become" });
          return false;
        }
      },
      // immediate: true,
    },
  },
  async created() {
    const motif = this.storage.get("motif");
    if (motif) {
      this.$store.commit("setMotif", motif);
    }

    this.isToken();
    this.setHeight();
    // let chatList = this.storage.get("historyChatList");
    // if (chatList && chatList.length > 0) {
    // this.storage.set('historyChatList', chatList);
    // this.$store.commit("sethistoryChatList", chatList);
    // }

    window.addEventListener("resize", this.setHeight);
  },
  async mounted() {
    // this.logOut();
  },
  methods: {
    getMobileWidth() {
      return this.mobileWidth;
    },
    async setHeight() {
      await this.$nextTick();
      // const elList = document.getElementById("app");
      // if (window.innerHeight < 600 && this.inPc) {
      //   elList.style.height = 600 + "px";
      // } else {
      //   elList.style.height = window.innerHeight + "px";
      // }

      const screenWidth = window.innerWidth;
      if (screenWidth <= 768) {
        this.mobileWidth = true;
      } else {
        this.mobileWidth = false;
      }
    },
    openDownloadWindow() {
      window.open("/chat/download", "_blank");
    },
    isProtocol(type) {
        window.open(
            this.getServer() + "/chat/protocol?type=" + type,
            "_blank"
        );
    },
    setMotif(motif) {
      if (this.motif == motif) {
        return;
      }

      this.$store.commit("setMotif", motif);
      this.storage.set("motif", motif);
    },
  },
  destroyed() {
    window.removeEventListener("resize", this.setHeight);
  },
};
</script>

<style lang="less" scoped>
/* @import "~vant/lib/index.css"; */

.pc {
  background-color: #001235;
  background-color: var(--Gray_01);
  display: flex;
  flex-direction: column;
  min-width: 1280px;
  min-height: 600px;
  height: 100%;

  .pc-flex {
    display: flex;
    flex: 1;
    height: 0;
    padding-right: 48px;
    overflow: auto;

    .pc-right {
      flex: 1;
      width: 0;
      // min-width: 1024px;
      max-width: 1281px;
      margin: 0 auto 68px;
      border-radius: 32px;
      overflow: hidden;
      overflow-y: auto;
    }

    .statement-box{
      position: absolute;
      bottom: 16px;
      left: 50%;
      transform: translateX(-50%);
      color: rgba(152, 159, 173, 0.60);
      white-space: nowrap;
      font-size: 12px;
      text-align: center;
      line-height: 18px;

      span{
        color: #196FFF;
        font-weight: bold;
        cursor: pointer;
      }
    }

    .ie-class {
      // margin: 0;
      flex: none;
      width: 1281px;

      /deep/.tap-taber {
        width: 336px;
      }
    }
  }
}

.main-head {
  padding: 15px 23px;
  user-select: none;
  font-size: 0;
  display: flex;
  align-items: center;

  .ie-tips {
    flex: 1;
    font-size: 16px;
    color: #001235;
    margin: 0 32px;
    background: linear-gradient(90deg, #c3df48 0%, #80f4ff 100%);
    border-radius: 16px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
  }

  img {
    // width: 130px;
    height: 42px;
    flex-shrink: 0;
  }

  .download-ico {
    min-width: 110px;
    padding: 8px 16px;
    border-radius: 18px;
    background: #002748;
    background: var(--Gray_02);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 28px;
    cursor: pointer;
    flex-shrink: 0;

    .box-icon {
      fill: #e6e9ed;
      fill: var(--Gray_05);
      width: 20px;
      height: 20px;
      flex-shrink: 0;
      margin-right: 4px;
    }

    div {
      font-size: 14px;
      color: #e6e9ed;
      color: var(--Gray_05);
    }

    &:hover {
      background: #1a3d5a;
      background: var(--Gray_03);
    }
  }

  .about-us{
    margin-left: auto;
    color: #e6e9ed;
    color: var(--Gray_05);
    font-size: 14px;
    cursor: pointer;
  }

  .motif-box {
    display: flex;
    margin-left: 16px;
    background: #002748;
    background: var(--Gray_02);
    border: 1px solid #1a3d5a;
    border: 1px solid var(--Gray_03);
    height: 36px;
    width: 96px;
    position: relative;
    border-radius: 18px;
    cursor: pointer;

    div {
      flex: 1;
      position: relative;
      z-index: 2;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 16px;
        height: 16px;
      }
    }

    &::after {
      position: absolute;
      content: "";
      width: 46px;
      height: 100%;
      top: 50%;
      left: 0px;
      transform: translateY(-50%);
      background: #1a3d5a;
      background: var(--current-topic-color);
      border: 1px solid #1a3d5a;
      border: 1px solid var(--Gray_03);
      border-radius: 18px;
      transition: all 0.3s;
    }

    &.white-box {
      &::after {
        left: 50%;
        // right: 0;
      }
    }
  }
}

.min {
  height: 100%;
}

.about-us-pop.center{
  padding: 24px;
  width: 400px;
  background: #002748;
  background: var(--special-pop-underpainting);

  &.position-bottom{
    background: #002748;
  }

  /deep/ .title{
    margin-bottom: 24px;
  }

  .about-us-box{
    font-size: 14px;
    color: #E6E9ED;
    color: var(--Gray_05);

  }
}

.about-us-pop.position-bottom{
  background: #002748;
  padding: 1rem;

  .about-us-box{
    font-size: 0.875rem;
    color: #E6E9ED;

  }
}

.login-pop.center {
  background: #001235;
  background: var(--Gray_01);
  // background: #001235;
  padding: 16px;
  min-width: 480px;

  /deep/ .off-img {
    z-index: 2;
  }

  /deep/ .login {
    background: none;
    width: 100%;

    .bg,
    .logo,
    .log-pc,
    .top-show {
      display: none;
    }

    .w-1200 {
      width: auto;
    }

    .card {
      background: none;
      width: 100%;
      min-height: 392px;

      .transition-box {
        .title-top {
          color: #e6e9ed;
          color: var(--Gray_05);
          font-size: 28px;
          line-height: 40px;
          font-weight: bold;
        }

        .columns-box {
          .columns-ul {
            background: #002748;
            background: var(--Gray_02);
            width: 100%;

            &::-webkit-scrollbar-track {
              background: transparent;
            }
            &::-webkit-scrollbar-thumb {
              background: #001235;
              background: var(--Gray_01);
            }

            li {
              line-height: 40px;
              border-radius: 4px;
              color: #e6e9ed;
              color: var(--Gray_05);

              &:hover {
                background: #1a3d5a;
                background: var(--Gray_03);
              }

              &.select {
                color: #00e3f9;
                color: var(--Cyan_01);
              }
            }
          }
        }

        .form-absolute {
          .van-cell {
            background: #001235;
            background: var(--Gray_01);
            border-color: #1a3d5a;
            border-color: var(--Gray_03);
            height: 64px;

            .van-field__label {
              border-color: #1a3d5a;
              border-color: var(--Gray_03);
            }

            &.focus {
              border-color: #00e3f9 !important;
              border-color: var(--Cyan_01) !important;
            }

            &.code {
              height: 60px;
            }
          }

          .columns-code {
            font-size: 18px;
            display: flex;
            align-items: center;
            color: #e6e9ed;
            color: var(--Gray_05);

            .arrow-down {
              margin-left: 4px;
              fill: #e6e9ed;
              fill: var(--Gray_05);
            }
          }

          .van-field__control {
            color: #e6e9ed;
            color: var(--Gray_05);
            font-size: 18px;
          }

          .agreement {
            margin-bottom: 32px;

            .agreement-icon {
              width: 20px;
              height: 20px;
              margin-right: 8px;
            }
            .agreement-box {
              font-size: 14px;
              color: #989fad;
              color: var(--Gray_04);

              .agreement-content {
                color: #00e3f9;
                color: var(--Cyan_01);
              }
            }
          }
        }

        .security {
          .security-code-container {
            .field-wrap {
              width: 56px;
              height: 56px;
              background: #001235;
              background: var(--Gray_01);
              border-color: #1a3d5a;
              border-color: var(--Gray_03);
              color: #e6e9ed;
              color: var(--Gray_05);
              font-weight: bold;

              &.cursor {
                border-color: #00e3f9;
                border-color: var(--Cyan_01);

                &::after {
                  background: #00e3f9;
                  background: var(--Cyan_01);
                }
              }
            }
          }
        }

        .back-img {
          // position: absolute;
          // top: -8px;
          margin-top: -28px;
          margin-left: -16px;
          margin-bottom: 49px;
        }

        .title-prompt {
          margin-bottom: 32px;
        }

        .reacquire {
          margin: 16px 0 30px;
          color: #00e3f9;
          color: var(--Cyan_01);
        }

        .log-btn {
          height: 56px;
          background: linear-gradient(90deg, #c3df48 0%, #80f4ff 100%);
          background: linear-gradient(
            90deg,
            var(--Ygreen_01) 0%,
            var(--Cyan_02) 100%
          );
        }
      }
    }
  }

  /deep/ .code-pop.center {
    background: #001235;
    background: var(--Gray_01);

    .title {
      color: #e6e9ed;
      color: var(--Gray_05);
    }

    .code-retry {
      .van-cell {
        background: #001235;
        background: var(--Gray_01);
        border-color: #1a3d5a;
        border-color: var(--Gray_03);

        .van-field__label {
          border-color: #1a3d5a;
          border-color: var(--Gray_03);
        }

        &.focus {
          border-color: #001235 !important;
          border-color: var(--Cyan_01) !important;
        }
      }

      .van-field__control {
        color: #e6e9ed;
        color: var(--Gray_05);
      }
    }

    .btn-box {
      .btns {
        background: linear-gradient(90deg, #00e3f9 0%, #0085a0 100%) !important;
        background: linear-gradient(
          90deg,
          var(--Ygreen_01) 0%,
          var(--Cyan_02) 100%
        ) !important;

        &:first-child {
          background: #1a3d5a !important;
          background: var(--pop-btn-cancel-color) !important;
          color: #e6e9ed !important;
          color: var(--Gray_05) !important;
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .taber-left.pc-left,
  .main-head {
    display: none;
  }

  .moblie-mine {
    /deep/ .pc-left {
      margin: 0;
      padding: 1.5rem 1.5rem 3.125rem;
      border: none;
      border-radius: 0;
      display: flex;
      width: 100%;

      .left-box {
        width: 100%;
      }

      .chat-list {
        margin-right: -1.5rem;
        flex-grow: 0;
        overflow: visible;
        padding-bottom: 4.7rem;
        height: auto;
        
        .left-box {
          width: calc(100% - 1.5rem);
        }
      }
    }
  }

  .pc {
    min-width: auto;
    padding-right: 0;
    min-height: auto;

    .pc-flex {
      padding-right: 0;

      &::-webkit-scrollbar{
        display: none;
      }

      .pc-right {
        border: none;
        border-radius: 0;
        margin: 0;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/App.vue